import React, { useMemo } from 'react'
import { ExtendingRow, Table } from '@ztechapps/webui.data-tools'
import { useInvoiceListContext } from './Context'
import { CheckboxInput } from '@ztechapps/webui.input'
import { Extension } from './Extension'
import { CellWithContextMenu } from '@ztechapps/webui.menu'
import { RowContextMenu } from './context-menu/RowContextMenu'
import { Stack } from 'react-bootstrap'
import { InvoiceStatus } from '../../../components/invoice/InvoiceStatus'
import { LocalDate } from '@ztechapps/webui.date'
import { formatMoney } from '@ztechapps/common.utils'
import type { Invoice } from '@ztechapps/totalmilk-payme.contract'
import type { EntityWithSelection } from '@ztechapps/common.hook'
import { RemarksInlineInput } from './RemarksInlineInput'
import { LoadMoreButton } from '@ztechapps/webui.button'

const ListHeader = () => {
  const { listWithSelection } = useInvoiceListContext()
  const { toggleSelectAll, hasSelectedAll } = listWithSelection

  return (
    <thead>
      <tr>
        <th style={{ width: '10px' }} className="px-1" />
        <th style={{ width: '10px' }} className="px-1">
          <CheckboxInput onChange={() => toggleSelectAll()} checked={hasSelectedAll} />
        </th>
        <th style={{ width: '30%' }}>Name</th>
        <th style={{ width: '20%' }}>Company Name</th>
        <th style={{ width: '80px' }}>Status</th>
        <th style={{ width: '100px' }}>Issue Date</th>
        <th style={{ width: '15%' }}>Remarks</th>
        <th style={{ width: '130px' }} className="text-end">
          Net Amount
        </th>
      </tr>
    </thead>
  )
}

const ListRow = (props: EntityWithSelection<Invoice>) => {
  const { listWithSelection } = useInvoiceListContext()

  return (
    <ExtendingRow {...props} colSpan={8} extensionRow={<Extension {...props} />}>
      <td className="px-1">
        <CheckboxInput
          checked={props._selected}
          onChange={() => {
            listWithSelection.toggleSelectBy((e) => e._id === props._id)
          }}
        />
      </td>
      <CellWithContextMenu contextMenuContent={<RowContextMenu invoice={props} />}>
        <div>
          <Stack>
            <div>
              {props?.code} {props?.name}
            </div>
          </Stack>
        </div>
      </CellWithContextMenu>

      <td>{props?.billTo?.company?.name ?? props?.billTo?.profile?.name ?? 'unknown customer'}</td>
      <td>
        <InvoiceStatus status={props?.status} />
      </td>
      <td>{<LocalDate value={props?.date} />}</td>

      <td>
        <RemarksInlineInput invoice={props} />
      </td>

      <td className="text-end">
        <h4>{formatMoney(props?.netAmount)}</h4>
      </td>
    </ExtendingRow>
  )
}

export const List1 = () => {
  const context = useInvoiceListContext()
  return (
    <div>
      <table className="table table-hover table-striped">
        <ListHeader />
        <tbody>
          {context.listWithSelection.list.map((item) => (
            <ListRow key={item._id} {...item} />
          ))}
        </tbody>
      </table>
      <LoadMoreButton {...context.invoiceList} />
    </div>
  )
}

export const List = () => {
  const context = useInvoiceListContext()
  const head = useMemo(() => <ListHeader />, [])

  return (
    <Table
      head={head}
      dataArray={context?.listWithSelection?.list}
      row={ListRow}
      loading={context?.invoiceList?.loading}
      loadMoreEntries={context.invoiceList.loadMoreEntries}
      error={context.invoiceList.error}
    />
  )
}
